import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const archivedPlansRoute: InvariantJiraRoute = {
	name: 'archived-plans-directory',
	path: '/jira/plans/settings/archive',
	exact: true,
};
